// extracted by mini-css-extract-plugin
export default {"root":"Yuy2ql2c3HbA2pri6RDA","header":"ouQCoaWZDzj5uV5_rO9y","createdDate":"QNIkTUvPoL9suzJUc15I","fileItem":"UA4htfHPYipnXOVc8Eu8","placeHolderShimmer":"sNJCKucfEcAkfDEiJ_RS"};